<app-loader *ngIf="loading"></app-loader>

<section class="user-details" *ngIf="paymentInfo">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">

        <div class="auction-content-main mb-4 mb-md-0 position-relative">
          <div class="auction-content-body p-4">
            <p class="auction-status auction-status--online">Purchased</p>
            <div class="user-details__user border-bottom py-4">
              <div class="user-details__userThumb mr-2">
                <img src="{{paymentInfo['frontImg']}}" alt="">
              </div>
              <div class="user-details__userInfo">
                <h3 class="heading-tertiary mb-1">
                  {{ paymentInfo['vehicle_name'] }}
                </h3>
                <h3 class="fs-normal color-gray d-flex align-items-center">
                  <i class="las la-map-marker-alt ion-lg mr-1"></i>
                  {{ paymentInfo?.['location'] ? paymentInfo['location'] : '--' }}
                </h3>

                <h3 class="fs-normal d-flex align-items-center">Payment ID -
                  {{ paymentInfo?.['payment_uuid'] ? paymentInfo['payment_uuid'] : '--' }}
                </h3>
              </div>
            </div>

            <div class="user-details__credentials border-bottom py-4">
              <div class="container">Order Details
                <div class="row">
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled auctionCarInfo__listKeyList">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Purchase Date:</span>
                      </li>

                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Delivery Date:</span>
                      </li>

                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">City</span>
                      </li>

                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Address 1:</span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['created_at'] | date: 'MMM d, y':'UTC +3' }}
                        </span>
                      </li>

                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['order_date'] | date: 'MMM d, y':'UTC +3' }}
                        </span>
                      </li>

                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['address_1'] }}
                        </span>
                      </li>

                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['city'] }}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Contact No:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Email:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">nationality:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Address 2:</span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['contact_number'] }}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['email'] }}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['nationality']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{ paymentInfo['address_2'] }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="user-details__credentials py-4">
              <div class="container">Vehicle Details
                <div class="row">
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled auctionCarInfo__listKeyList">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Body Type:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Interior:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Exterior:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Stock Number:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">VIN:</span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Body Type']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Interior Colour']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Exterior Colour']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">57576766</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['VIN Number']}}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Engine Type:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Transmission Type:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Drive Type:</span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listKey">Fuel Type:</span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3">
                    <ul class="list-unstyled">
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Engine Type']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Transmission Type']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Drive Type']}}
                        </span>
                      </li>
                      <li class="mt-2">
                        <span class="auctionCarInfo__listValues">
                          {{paymentInfo?.['description_data']?.['Fuel Type']}}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <ng-container *ngIf="paymentDocs && paymentDocs.length">
        <div class="col-md-6">
          <div class="auction-content-main">
            <div class="auction-content-body p-4 text-center">
              <h3 class="fs-md">
                Documents of {{paymentInfo['first_name'] + ' ' + paymentInfo['last_name']}}
              </h3>
              <div class="timeLineBox">
                <ul class="list-unstyled timeLine">
                  <ng-container *ngFor="let document of paymentDocs; index as i">
                    <li class="timeLine__item">
                      <div class="timeLine__data d-flex align-items-center justify-content-evenly">
                        <div class="d-flex flex-column align-items-start">
                          <h5 class="fs-sm fw-600 mb-1 text-capitalize">
                            {{document['document_name']}}
                          </h5>
                          <p class="m-0">
                            {{document['created_at'] | date:'MMM d, y, h:mm a'}}
                          </p>
                        </div>

                        <div>
                          <button type="button" class="btn curved yellow mr-2 rounded" style="width: fit-content"
                            (click)="viewDocument(document['imageUrl']['presigned_url'])">
                            View
                          </button>

                          <button type="button" class="btn curved green mr-2 rounded" style="width: fit-content"
                            [disabled]="document['order_document_status'] === true"
                            *ngIf="document['order_document_status'] === null || document['order_document_status'] === true"
                            (click)="userDocStatusUpdate(document['doc_id'], '1', i)" [ladda]="laddaBtnStates[i]">
                            {{document['order_document_status'] === true ? 'Approved' : 'Approve'}}
                          </button>
                          <button type="button" class="btn curved red mr-2 rounded" style="width: fit-content"
                            [disabled]="document['order_document_status'] === false"
                            *ngIf="document['order_document_status'] === null || document['order_document_status'] === false"
                            (click)="openRejectWhyModal(rejectReasonModal, document['doc_id'], '0', i,document['document_name'])" [ladda]="laddaBtnStates[i]">
                            {{document['order_document_status'] === false ? 'Rejected' : 'Reject'}}
                          </button>
                        </div>
                      </div>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>

            <div class="payment_status_btn p-4">
              <div class="auction-payment d-flex" *ngIf="enableReserve && (paymentInfo['buy_status'] !== '2' || paymentInfo['buy_status'] !== '1' )">
                <h4 class="fw-500">Reserve Status: {{reserveStatus}}</h4>

                <div class="d-flex align-items-center justify-content-center">
                  <button type="button" class="btn btn__main curved green px-4 ml-2" [ladda]="laddaReserveBtn"
                    *ngIf="paymentInfo['payment_order_type_status'] === false || paymentInfo['payment_order_type_status'] === null"
                    (click)="updateReserveStatus(paymentInfo['product_id'], '1', paymentInfo['vehicle_id'])"> Reserve
                  </button>

                    <button 
                      type="button"
                      class="btn btn__main curved red px-4 ml-2"
                      [ladda]="laddaReserveBtn"
                      *ngIf="paymentInfo['payment_order_type_status'] === true && !showSellOption"
                      (click)="updateReserveStatus(paymentInfo['product_id'], '0', paymentInfo['vehicle_id'])"
                      > 
                        Unreserve
                    </button>
                  </div>
                </div>
                <div class="payment-status-heading" *ngIf="showSellOption">
                  <h4>{{paymentInfo['buy_status'] === '0' ? 'Sell Vehicle' : 'Vehicle Sold'}}</h4>
                  <img class="paymentIcons" *ngIf="paymentInfo['buy_status'] === '0'" src="{{env + 'assets/img/pending-clock-icon.png'}}">
                  <img class="paymentIcons" *ngIf="(paymentInfo['buy_status'] === '2' || paymentInfo['buy_status'] === '1')" src="{{env + 'assets/img/checkmark-flat.svg'}}">
                </div>
                <div class="auction-payment" *ngIf="showSellOption && paymentInfo['buy_status'] === '0'">
                  <button 
                    type="button"
                    class="btn btn__main curved yellow"
                    [ladda]="laddaSellButton"
                    [disabled]="(paymentInfo['buy_status'] === '2' || paymentInfo['buy_status']==='1')"
                    (click)="openPDIModal(pdi)"
                    >
                    Sell
                  </button>
                </div>
              </div>

            <div class="row justify-content-center" *ngIf="(paymentInfo['buy_status'] === '2' || paymentInfo['buy_status'] === '1')">
              <button class="btn btn__main curved yellow" (click)="openDocsUploadModal(DocsModal)">Upload Documents</button>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</section>

<!-- Modal -->
<ng-template #DocsModal>
  <div class="modal-header">
    <h4 class="fs-lg fw-500 text-center">Upload Documents</h4>
    <button type="button" title="Close modal" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngFor="let doc of globalDocsObj | keyvalue; index as i"
    class="d-flex align-items-center justify-content-between border-bottom pb-3" [class]="i > 0 ? 'mt-3' : ''"> 
      <div class="d-flex flex-column">
        <label for="" class="fs-md fw-500 mb-2">{{doc['key']}}</label>
        <input *ngIf="!doc['value']['available']" type="file" accept="image/jpeg, .pdf"
          (change)="getDocument($event, doc['key'])">
        <p *ngIf="doc['value']['available']" class="fs-normal fw-300 m-0">{{ doc['value']['uploadTime']| date:'MMM d, y, h:mm a'}}</p>
      </div>
      <div>
        <button *ngIf="!doc['value']['available']" class="btn curved yellow rounded"
          [disabled]="!doc['value']['enableUpload']" [ladda]="laddaBtnStatesInModal[i]"
          (click)="uploadDocument(paymentInfo['product_id'], doc['key'], i)" title="Upload {{doc['key']}}">Upload</button>
        <button *ngIf="doc['value']['available']" class="ml-2 btn curved yellow rounded"
          (click)="viewDocument(doc['value']['imageUrl'])" title="View {{doc['key']}}">View</button>
        <button [disabled]="!doc['value']['available']" class="ml-2 btn curved red rounded" [ladda]="laddaBtnStatesInModal[i]"
          (click)="deleteAfterSellDocs(productId, doc['value']['id'], doc['key'], i)" title="Delete {{doc['key']}}">Delete</button>
      </div>
      
    </div>
  </div>
</ng-template>

<ng-template #rejectReasonModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left p-0 fs-lg">Why reject {{rejectedDocName}}?</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <textarea class="w-100 border reject-txt-area p-2 text-dark" cols="30" rows="10" [(ngModel)]="whyReject" placeholder="Please describe why document is rejected"></textarea>
      <div class="d-flex flex-row-reverse mt-2">
        <button class="btn curved yellow rounded ml-2" [ladda]="rejectLaddaBtn" (click)="onSubmitReject()">Submit</button>
        <button class="btn curved gray rounded" (click)="modalRef?.hide()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- PDI Modal -->
<ng-template #pdi>
  <div class="modal-header">
    <h4 class="modal-title pull-left">PDI Modal</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">

    <div class="d-flex flex-column align-items-center" *ngIf="employeeList.length; else loadingEmployeeList">
      <label class="fs-md fw-300 mb-2 credential2__label">Please select an employee</label>
      <select class="credential2__select form-control w-auto" (change)="onOptionChanged($event.target.value)">
        <option value="">Select an employee</option>
        <option *ngFor="let employee of employeeList; index as i" [value]="i">{{employee['first_name'] + ' ' + employee['last_name']}}</option>
      </select>
      <button class="btn curved green mt-2 rounded" [ladda]="laddaSellButton" [disabled]="employeePhone === ''" (click)="completeSell()">Done</button>
    </div>

    <ng-template #loadingEmployeeList>
      <p>Loading...</p>
    </ng-template>
    
  </div>
</ng-template>